import "@/App.css";
import "@/index.css";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Ecosystem } from "./components/Ecosystem";
import { Features } from "./components/Features";
import { HowItWorks } from "./components/HowItWorks";
import { Tokenomics } from "./components/Tokenomics";
import { Roadmap } from "./components/Roadmap";
import { Security } from "./components/Security";
import { Team } from "./components/Team";
import { Partners } from "./components/Partners"; 
import { FAQ } from "./components/FAQ";
import { CTA } from "./components/CTA";
import { Footer } from "./components/Footer";

const AppContent = () => {
  const { isDark } = useTheme();
  
  return (
    <div 
      className={`min-h-screen transition-colors duration-300 ${
        isDark ? 'bg-[#050505]' : 'bg-[#F8FAFC]'
      }`}
    >
      <Navbar />
      <main>
        <Hero />
        <About />
        <Ecosystem />
        <Features />
        <HowItWorks />
        <Tokenomics />
        <Roadmap />
        <Security />
        <Team />
        <Partners />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};



function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
